import "./MTDITSA.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import Features from "./sections/Features";
import Team from "./sections/Team";
import Footer from "@/reusable_sections/Footer";
export default function MTDITSAPage() {
  return <div>
      <Header />
      <Hero />
      <Features />
      <Team />
      <Footer />
    </div>;
}